import React, { useState } from "react";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getHeader } from "../../utils/util";

const DialogSubmit = ({
  open,
  onClose,
  title = "Submit",
  inputLabel = "Your text",
  submitLabel = "Submit",
  endpoint = "/",
  method = "post",
  transformPayload = (text) => ({ text }),
  onSuccess = () => {},
  onError = () => {},
}) => {
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    if (!loading) {
      setValue("");
      onClose();
    }
  };
  const handleSubmit = async () => {
    if (!value.trim()) return;
    setLoading(true);
    try {
      const { data } = await axios({
        url: endpoint,
        method,
        data: transformPayload(value.trim()),
        ...getHeader(),
      });
      onSuccess(data);
      handleClose();
    } catch (err) {
      onError(err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
      <DialogTitle sx={{ fontWeight: 600 }}>
        {title}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <TextField
          autoFocus
          fullWidth
          label={inputLabel}
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading || !value.trim()}
        >
          {loading ? <CircularProgress size={24} /> : submitLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogSubmit;
